<template>
<v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
        <v-badge
            :content="unread"
            :value="unread"
            color="red"
            overlap
            dot
        >
            <v-icon v-bind="attrs" v-on="on" color="white">mdi-bell-outline</v-icon>
        </v-badge>
    </template>
    <v-list max-width="350">
        <template v-for="(item, index) in this.getNotifications.slice(0, 5)">
            <v-list-item
                :key="index"
                @click="doNothing()">
                <v-list-item-content @click="actionClick(item, 'link')">
                    <v-list-item-title v-text="item.title" v-bind:class="{ 'font-weight-medium': !item.isAcknowledge }"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action @click="actionClick(item, 'toggleAck')">
                    <v-list-item-action-text>{{ item.updatedDate | moment("from") }}</v-list-item-action-text>
                        <v-icon
                            v-if="!item.isAcknowledge"
                            color="info">
                            mdi-email-outline
                        </v-icon>

                        <v-icon
                            v-else>
                            mdi-email-open-outline
                        </v-icon>
                </v-list-item-action>
            </v-list-item>
            <v-divider
                v-if="index + 1 < getNotifications.slice(0, 5).length"
                :key="index"
            ></v-divider>
        </template>
        <v-divider />
        <v-list-item to="/notifications">
            <v-list-item-content>
                <v-list-item-title class="text-center">SEE ALL</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    data: () => ({
        items: [],
    }),
    created() {
        this.items = this.getNotifications;
    },
    computed: {
        ...mapGetters(['getNotifications']),
        unread() {
            return this.getNotifications.reduce((acc, item) => item.isAcknowledge ? acc : acc + 1, 0);
        }
    },
    methods: {
        ...mapActions(['toggleAckNotification']),
        doNothing() { return },
        actionClick(item, action) {
            if (action === 'link' && this.$route.path != item.link) {
                this.$router.push({ path: item.link });
            }
            if (action === 'toggleAck') {
                this.toggleAckNotification(item.id);
            }
        }
    }
}
</script>

<style>

</style>